/* eslint-disable jsx-quotes */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { withRouter } from 'react-router-dom';

import QuestionsDatabase from '../questions-database/questions-database';
import Tests from '../tests/tests';
import TestsConducted from '../tests-conducted/tests-conducted';

import history from '../../history';
import routes from '../../utils/routes';

import 'react-tabs/style/react-tabs.css';
import './online-tests.css';

const PATHS = {
    DATABASE_QUESTION: '/admin/online-tests/questions',
    TEMPLATE_TESTS: '/admin/online-tests/template-tests',
    PERFORMED_TESTS: '/admin/online-tests/performed-tests',
};

class OnlineTests extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: null,
            currentRoute: '',
        };
    }

    componentDidMount() {
        this.checkPath();
    }

    componentDidUpdate(prevProps) {
        const {
            match: { path },
        } = this.props;

        if (prevProps.match.path !== path) {
            this.checkPath();
        }
    }

    checkPath() {
        const {
            match: { path },
        } = this.props;

        if (path === PATHS.DATABASE_QUESTION) {
            this.setState({ index: 0 });
        } else if (path === PATHS.TEMPLATE_TESTS) {
            this.setState({ index: 1 });
        } else if (path === PATHS.PERFORMED_TESTS) {
            this.setState({ index: 2 });
        }
    }

    goToQuestionsDatabase() {
        history.push(routes.QUESTIONS_DATABASE);
    }

    goToPerformedTest() {
        history.push(routes.PERFORMED_TESTS);
    }

    goToTests() {
        history.push(routes.TEMPLATE_TESTS);
    }

    handleTable({ newIndexTable }) {
        if (newIndexTable === 0) {
            this.goToQuestionsDatabase();
        } else if (newIndexTable === 1) {
            this.goToTests();
        } else if (newIndexTable === 2) {
            this.goToPerformedTest();
        }
    }

    render() {
        const { index } = this.state;

        return (
            <main className="container-online-tests">
                <Tabs
                    selectedTabClassName="tab-selected"
                    selectedIndex={Number(index)}
                    onSelect={tabIndex =>
                        this.handleTable({ newIndexTable: tabIndex })
                    }
                >
                    <TabList>
                        <Tab className="react-tabs__tab tab tab-focus-fixed">
                            Banco de Questões
                        </Tab>
                        <Tab className="react-tabs__tab tab tab-focus-fixed">
                            Testes
                        </Tab>
                        <Tab className="react-tabs__tab tab tab-focus-fixed">
                            Relatórios de Teste
                        </Tab>
                    </TabList>

                    <TabPanel>{index === 0 && <QuestionsDatabase />}</TabPanel>
                    <TabPanel>{index === 1 && <Tests />}</TabPanel>
                    <TabPanel>{index === 2 && <TestsConducted />}</TabPanel>
                </Tabs>
            </main>
        );
    }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OnlineTests),
);



// WEBPACK FOOTER //
// ./src/components/online-tests/online-tests.js